import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapPinOff } from "lucide-react";
import { OpenBadge } from "./profile/StoreMap";

const PIN = L.divIcon({
  className: "",
  html: `<svg width="28" height="38" viewBox="0 0 30 40"><path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.7 23.3 0 15 0z" fill="#F5551E"/><circle cx="15" cy="15" r="6" fill="#fff"/></svg>`,
  iconSize: [28, 38], iconAnchor: [14, 38], popupAnchor: [0, -34],
});

export const DirectoryMap = ({ list, noun }) => {
  const pins = list.filter((b) => b.store_lat != null && b.store_lng != null);
  const bounds = pins.length ? L.latLngBounds(pins.map((b) => [b.store_lat, b.store_lng])).pad(0.3) : null;
  return (
    <div data-testid="directory-map-view">
      <div className="h-[560px] rounded-2xl overflow-hidden border border-slate-200/80 relative z-0">
        <MapContainer key={pins.map((b) => b.user_id).join(",")} {...(pins.length > 1 ? { bounds } : { center: pins.length ? [pins[0].store_lat, pins[0].store_lng] : [56, -96], zoom: pins.length ? 13 : 4 })}
          scrollWheelZoom className="h-full w-full">
          <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {pins.map((b) => (
            <Marker key={b.user_id} position={[b.store_lat, b.store_lng]} icon={PIN}>
              <Popup>
                <div className="min-w-[180px]" data-testid={`directory-pin-${b.user_id}`}>
                  <Link to={`/seller/${b.user_id}`} className="font-bold !text-[#12234A] hover:!text-[#F5551E]">{b.name}</Link>
                  <p className="text-xs text-slate-500 mt-1 !m-0">{b.store_address}</p>
                  <div className="mt-2"><OpenBadge open={b.open_now} closure={b.closed_today} testid={`directory-pin-open-${b.user_id}`} /></div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      <p className="text-sm text-slate-500 mt-3 flex items-center gap-1.5" data-testid="directory-map-count">
        {pins.length ? `${pins.length} store front${pins.length === 1 ? "" : "s"} on the map.` : <><MapPinOff size={15} /> {`None of these ${noun} have a store front on the map yet.`}</>}
        {pins.length > 0 && list.length > pins.length && (list.length - pins.length === 1 ? " 1 other sells online or hasn't added a store address." : ` ${list.length - pins.length} others sell online or haven't added a store address.`)}
      </p>
    </div>
  );
};
